import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";

export default class UpdateProduct extends Component {
  state = {
    id: "",

    product_name: "",
    product_category: "",
    description: "",
    product_image: null,
    existing_image: "",

    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  /* =========================
     LOAD PRODUCT
  ========================= */
  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id }, () => this.fetchProduct(id));
  }

  fetchProduct = async (id) => {
    if (init() !== "success") return this.setState({ redirect: true });

    try {
      const res = await axios.get(
        Constants.getUrls.getAllProducts + "/" + id
      );

      const p = res.data.data;

      this.setState({
        product_name: p.product_name,
        product_category: p.product_category,
        description: p.description || "",
        existing_image: p.product_image,
      });
    } catch {
      this.setState({
        notification: true,
        message: "Failed to load product",
      });
    }
  };

  /* =========================
     HANDLERS
  ========================= */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /* =========================
     SUBMIT
  ========================= */
  handleSubmit = async (e) => {
    e.preventDefault();
    if (init() !== "success") return this.setState({ redirect: true });

    this.setState({ loading: true });

    const formData = new FormData();
    formData.append("product_name", this.state.product_name);
    formData.append("product_category", this.state.product_category);
    formData.append("description", this.state.description);

    if (this.state.product_image) {
      formData.append("product_image", this.state.product_image);
    }

    try {
      await axios.put(
        Constants.putUrls.updateProduct + this.state.id,
        formData
      );

      this.setState({
        notification: true,
        message: "Product updated successfully",
        loading: false,
      });

      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Update failed",
        loading: false,
      });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    if (this.state.redirect) return <Navigate to="/products" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
            >
              <MDTypography color="white">Update Product</MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* PRODUCT NAME */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      required
                      label="Product Name"
                      name="product_name"
                      value={this.state.product_name}
                      onChange={this.handleChange}
                      style={{marginTop: "20px"}}
                    />
                  </Grid>

                  {/* PRODUCT CATEGORY */}
                  <Grid item xs={6}>
                    <InputLabel sx={{ mb: 1 }}>Product Category</InputLabel>

                    <Select
                      fullWidth
                      required
                      name="product_category"
                      value={this.state.product_category}
                      onChange={this.handleChange}
                      displayEmpty
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="">Select Category</MenuItem>

                      <MenuItem value="Single Seeds for Birds">
                        Single Seeds for Birds
                      </MenuItem>

                      <MenuItem value="Bird Feed Mixes">
                        Bird Feed Mixes
                      </MenuItem>

                      <MenuItem value="HummingBird Food">
                        HummingBird Food
                      </MenuItem>

                      <MenuItem value="Other Products">Other Products</MenuItem>
                    </Select>
                  </Grid>

                  {/* EXISTING IMAGE */}
                  {this.state.existing_image && (
                    <Grid item xs={12}>
                      <img
                        src={Constants.imageDomain + this.state.existing_image}
                        alt="Product"
                        style={{ height: 120, objectFit: "contain" }}
                      />
                    </Grid>
                  )}

                  {/* REPLACE IMAGE */}
                  <Grid item xs={6}>
                    <TextField
                      type="file"
                      label="Replace Product Image"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({
                          product_image: e.target.files[0],
                        })
                      }
                      style={{ marginTop: "20px" }}
                    />
                  </Grid>

                  {/* DESCRIPTION */}
                  <Grid item xs={12}>
                    <MDTypography mb={1}>
                      Product Description (Optional)
                    </MDTypography>

                    <SunEditor
                      setContents={this.state.description}
                      onChange={(content) =>
                        this.setState({ description: content })
                      }
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["undo", "redo"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                    />
                  </Grid>
                </Grid>

                <MDBox mt={3}>
                  <MDButton
                    type="submit"
                    color="info"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Updating..." : "Update Product"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              open={this.state.notification}
              content={this.state.message}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
